import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { bind, CardItem, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { BsFillCaretDownFill } from '@react-icons/all-files/bs/BsFillCaretDownFill';
import { BsFillCaretUpFill } from '@react-icons/all-files/bs/BsFillCaretUpFill';
import { Collapse } from 'reactstrap';

export interface IInfiniteTouchCardProps {
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
    readonly loading?: boolean;
}

@observer
export class InfiniteTouchCard extends React.Component<IInfiniteTouchCardProps> {
    public render() {
        const statusPoll = this.props.statusPoll;

        return (
            <StatusCard title="InfiniteTouch®" loading={this.props.loading}>
                {statusPoll?.sigmaSense?.touchScreens?.map((t, k) => (
                    <TouchScreenItem key={k} touchScreen={t} index={k} />
                ))}
            </StatusCard>
        );
    }
}

export interface ITouchScreenItemProps {
    readonly touchScreen: Mri.WebApi.TouchScreen;
    readonly index: number;
}

@observer
export class TouchScreenItem extends React.Component<ITouchScreenItemProps> {
    public render() {
        const { touchScreen, index } = this.props;

        return (
            <>
                <a className="p-0 p-md-2" onClick={this.onToggle}>
                    <b>
                        {`TouchScreen ` + (index + 1)} &nbsp;
                        {this.collapsed && <BsFillCaretDownFill />}
                        {!this.collapsed && <BsFillCaretUpFill />}
                    </b>
                </a>

                <Collapse isOpen={!this.collapsed}>
                    <CardItem
                        label="Api Version"
                        value={
                            <span>
                                {touchScreen.apiMajorVersion}.{touchScreen.apiMinorVersion.toString().padStart(2, '0')}
                            </span>
                        }
                    />
                    <CardItem label="Firmware Version" value={touchScreen.firmwareVersion} />
                    <CardItem label="Expected Json File" value={touchScreen.expectedJsonFile} />
                    <CardItem label="Uptime" value={touchScreen.uptime} />
                    <CardItem label="Error Flags" value={touchScreen.errorFlags} />
                    <CardItem label="Brutus Status" value={touchScreen.brutusStatus} />
                    <CardItem label="Usb Status" value={touchScreen.usbStatus} />
                    <CardItem label="Dmsg Flags" value={touchScreen.dmsgFlags} />
                    <CardItem label="Frame Count" value={touchScreen.frameCount} />
                    <CardItem label="Frame Rate" value={touchScreen.frameRate} />
                    <CardItem label="Touch Count" value={touchScreen.touchCount} />
                    <CardItem label="Touch Id" value={touchScreen.touchId} />
                    <CardItem label="Railed Count" value={touchScreen.railedCount} />
                    <CardItem label="Noisy Frequency Count" value={touchScreen.noiseCount} />
                    <CardItem label="Mitigating Reset Count" value={touchScreen.overdriveResets} />
                    <CardItem label="Self Amplitude" value={touchScreen.selfAmplitude} />
                    <CardItem label="Rebaseline Count" value={touchScreen.rebaselineCount} />
                    <CardItem label="CDAC Setting" value={touchScreen.cdacSetting} />
                    <CardItem label="Update Status Message" value={touchScreen.updateStatusMessage} />
                </Collapse>
            </>
        );
    }

    @bind
    @action
    private onToggle() {
        this.collapsed = !this.collapsed;
    }

    @observable
    private collapsed = true;
}
